<template>
  <el-dialog
    title="完善门店坐标"
    :visible.sync="visible"
    width="378px"
    top="40vh"
    center
    show-close
    class="address-dialog"
  >
    <div class="content">申请处方之前请及时设置</div>
    <span slot="footer">
      <el-button class="btn btn-cancel" plain @click="cancel">取 消</el-button>
      <el-button class="btn" type="primary" @click="goSetUp">前往设置</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Fetch from '@/api';
import { getDistanceRole } from '@/util';

export default {
  data() {
    return {
      visible: false
    };
  },
  computed: {
    userId() {
      return this.$store.getters.userId;
    },
    roleList() {
      return this.$store.state.permission.roles || [];
    },
    disRole() {
      // 店长兼药师 = 1, 店长 = 2, 店员 = 3, 药师 = 4, 其他 0
      return getDistanceRole(this.roleList);
    }
  },
  async created() {
    await this.$store.dispatch('permission/getInfo');
    let res = await Fetch.select_store_longitudeLatitude({ id: 0 });
    const { updateCount, flag } = res;

    if (updateCount === 0 && flag !== 2) {
      // 2 手动更新了经纬度 undefined 为初始数据 1 自动更新了经纬度
      // 一次都为更新 调用自动更新接口
      if (this.disRole === 1 || this.disRole === 2 || this.disRole === 3) {
        if (!flag) {
          await this.$store.dispatch('global/autoUpdateDistance');
        }
        if (this.disRole === 1 || this.disRole === 2) {
          this.showDialog();
        }
      }
    }
  },
  methods: {
    showDialog() {
      let time = localStorage.getItem(`address_modal_${this.userId}_`, Date.now());
      console.log('lc time = ', time);
      if (Date.now() - new Date(time).getTime() > 1000 * 60 * 60 * 24 || !time) {
        this.visible = true;
        localStorage.setItem(`address_modal_${this.userId}_`, Date.now());
      }
    },
    goSetUp() {
      this.visible = false;
      this.$router.push('/shopManagement');
    },
    cancel() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.address-dialog {
  .content {
    margin: 0 auto;
    text-align: center;
  }
  /deep/.el-dialog__headerbtn {
    display: block !important;
  }
  .btn-cancel {
    color: #1e8dff !important;
    background: #fff !important;
  }
  .btn {
    width: 132px;
  }
}
</style>
